import { render, staticRenderFns } from "./CarFireInsuranceReserve.vue?vue&type=template&id=58734f56"
import script from "./CarFireInsuranceReserve.vue?vue&type=script&lang=js"
export * from "./CarFireInsuranceReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports